var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgGoldStar = function SvgGoldStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.779 12.142L7 11.259l2.221.883a1.45 1.45 0 001.983-1.44l-.154-2.386 1.527-1.84a1.45 1.45 0 00-.758-2.33l-2.316-.591-1.278-2.02a1.45 1.45 0 00-2.45 0l-1.278 2.02-2.316.59a1.45 1.45 0 00-.758 2.332L2.95 8.316l-.154 2.385a1.45 1.45 0 001.983 1.441z",
    fill: "#D4BB5E",
    stroke: "#020814",
    strokeWidth: 1.5
  })));
};
export default SvgGoldStar;